<template>
  <div class="container containerForm">
    <h2 style="text-align: center">تعديل إعدادات عامة</h2>
    <form @submit.prevent="updateSetting">
      <div class="form-group" v-for="field in formFields" :key="field.id">
        <label :for="field.id">{{ field.label }}</label>
        <input type="text" class="form-control" :id="field.id" v-model="editedSetting[field.id]" />
      </div>
      <div class="form-group">
        <label for="mapMarker">تغيير العنوان على الخريطة</label>
        <MapChange v-model="editedSetting.mapLocation" @update:markerLatLng="updateMarkerLatLng" />
      </div>
      <button type="submit" class="btn btn-primary">حفظ</button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";
import MapChange from "../../../Website/SharedUI/MapChange.vue";

export default {
  components: {
    MapChange,
  },
  data() {
    return {
      formFields: [
        { id: "email", label: "البريد الإلكتروني" },
        { id: "location_en", label: "العنوان بالإنجليزية" },
        { id: "location_ar", label: "العنوان بالعربية" },
        { id: "phone_1", label: "الهاتف الأول" },
        { id: "phone_2", label: "الهاتف الثاني" },
        { id: "facebooklink", label: "رابط الفيسبوك" },
        { id: "instagramlink_1", label: "رابط الإنستجرام الأول" },
        { id: "instagramlink_2", label: "رابط الإنستجرام الثاني" },
        { id: "exchangeRate", label: "سعر الدولار" },
      ],
      editedSetting: {
        email: "",
        location_en: "",
        location_ar: "",
        phone_1: "",
        phone_2: "",
        facebooklink: "",
        instagramlink_1: "",
        instagramlink_2: "",
        exchangeRate: "",
        mapLocation: { latitude: 0, longitude: 0 },
      },
      // Store the old values here
      oldSetting: null,
    };
  },

  methods: {
    updateMarkerLatLng(markerLatLng) {
      this.editedSetting.mapLocation.latitude = markerLatLng.lat;
      this.editedSetting.mapLocation.longitude = markerLatLng.lng;
    },

    fetchSettingDetails() {
      Axios.get("/generalSetting")
        .then((response) => {
          // Store the old values when fetching data
          this.oldSetting = { ...response.data };
          this.editedSetting = { ...response.data };
        })
        .catch((error) => {
          // console.error(error);
        });
    },

    updateSetting() {
      let formData = new FormData();
      // Append the updated fields to formData
      this.formFields.forEach((field) => {
        formData.append(field.id, this.editedSetting[field.id]);
      });

      // Append the map location
      formData.append('latitude', this.editedSetting.mapLocation.latitude);
      formData.append('longitude', this.editedSetting.mapLocation.longitude);

      if (Array.isArray(this.oldSetting.images)) {
        this.oldSetting.images.forEach((image, index) => {
          formData.append(`images[${index}]`, image);
        });
      }

      Axios.patch("/generalSetting", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          this.$iziToast.success({
            timeout: 2000,
            message: "تم التحديث بنجاح",
            position: "bottomRight",
          });
          this.$router.push("/admin/general-setting");
        })
        .catch((error) => {
          // console.error(error);
          this.$iziToast.error({
            timeout: 2000,
            message: "فشل التحديث",
            position: "bottomRight",
          });
        });
    },

  },

  mounted() {
    this.fetchSettingDetails();
  },
};
</script>
